"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const QueryFieldSelector_1 = __importDefault(require("./QueryFieldSelector"));
const predicateOperators = [
    { value: 'lessThan', label: '<' },
    { value: 'lessThanOrEqual', label: '\u2264' },
    { value: 'moreThan', label: '>' },
    { value: 'moreThanOrEqual', label: '\u2265' },
    { value: 'equal', label: '=' },
    { value: 'notEqual', label: '<>' },
    { value: 'ilike', label: 'LIKE' },
    { value: 'notIlike', label: 'NOT LIKE' },
    { value: 'fulltext', label: 'FULLTEXT' },
    // { value: 'like', label: 'LIKE' },
    { value: 'between', label: 'BETWEEN' },
    // { value: 'in', label: 'IN' }, // use "ANY" instead
    { value: 'any', label: 'ANY' },
    { value: 'isNull', label: 'IS NULL' }
];
const OperatorSelector = ({ column, value = 'equal', onChange }) => {
    const [operator, setOperator] = (0, react_1.useState)(value);
    let options = predicateOperators;
    switch (column.type) {
        case 'text':
        case 'jsonb':
        case 'boolean':
        case 'enum':
            if (column.type !== 'enum' ||
                (Array.isArray(column.enum) && column.enum.every(e => !isNaN(+e)))) {
            }
            options = predicateOperators.filter(o => ![
                'lessThan',
                'lessThanOrEqual',
                'moreThan',
                'moreThanOrEqual',
                'between',
                'last'
            ].includes(o.value));
            break;
    }
    if (column.type === 'tsvector') {
        // full text search
        options = options.filter(o => o.value === 'fulltext');
    }
    else if (column.type !== 'text') {
        options = options.filter(o => o.value !== 'fulltext');
    }
    return (react_1.default.createElement(QueryFieldSelector_1.default, { className: 'where-operator-selector', placeholder: 'Operator', value: predicateOperators.find(o => o.value === operator), options: options, getOptionLabel: option => (option === null || option === void 0 ? void 0 : option.label) || '', onChange: option => {
            setOperator(option.value);
            onChange === null || onChange === void 0 ? void 0 : onChange(option.value);
        } }));
};
exports.default = OperatorSelector;
//# sourceMappingURL=OperatorSelector.js.map